import React from 'react'
import styles from './Point.module.css'
import PointCard from './PointCard'

export default function Point() {
    const points = [
        {
            image: '/pages/business/hotelslabo/point_image_1.png',
            textImage: '/pages/business/hotelslabo/point_text_1.png',
            title: (
                <>
                    成果報酬型で
                    <br />
                    かけ捨てリスクゼロな採用
                </>
            ),
            description:
                '採用までは0円なので、面接でじっくり自社に合う人材か見定められます。求人広告には手を出しにくかった企業様も気軽に採用活動を始められます。',
        },
        {
            image: '/pages/business/hotelslabo/point_image_2.png',
            textImage: '/pages/business/hotelslabo/point_text_2.png',
            title: 'ホテル求人作り放題・掲載期限も無制限',
            description:
                '好きなだけ求人を作成して、欲しいホテル人材へアピールできます。さらに、求人を作成する過程で会社・ブランド特設ページが出来上がり、会社・ブランド単位でのアピールも可能です。',
        },
        {
            image: '/pages/business/hotelslabo/point_image_3.png',
            textImage: '/pages/business/hotelslabo/point_text_3.png',
            title: (
                <>
                    スカウト無料！
                    <br />
                    ホテル人材に
                    <br />
                    アプローチができる
                </>
            ),
            description:
                '採用したい人材の職種、働いていたホテル・施設を指定し無料でスカウトが送れます。採用したいホテル人材へダイレクトにアプローチすることができます。',
            subImage: '/pages/business/hotelslabo/point_sub_image.png',
        },
        {
            image: '/pages/business/hotelslabo/point_image_4.png',
            textImage: '/pages/business/hotelslabo/point_text_4.png',
            title: 'エージェントサポートでマッチしたホテル人材を紹介',
            description:
                '企業様が求人を作成し、採用活動をするのとは別に、弊社キャリアアドバイザーが募集要件にマッチした人材をご推薦することも可能です。エージェントサポートでは、面接の日程調整や条件交渉、入社までのサポートを行います。',
        },
    ]

    return (
        <section id='point' className={styles.point}>
            <h1 className={styles.pointH1}>
                <img
                    src='/pages/business/hotelslabo/point_h1.png'
                    alt='ホテルズラボが選ばれる4つの理由'
                />
            </h1>
            <ul className={styles.pointBox}>
                {points.map((point, index) => (
                    <PointCard
                        key={index}
                        image={point.image}
                        textImage={point.textImage}
                        title={point.title}
                        description={point.description}
                        subImage={point.subImage}
                    />
                ))}
            </ul>
            <div className={styles.pointCta}>
                <a className={styles.cta} href='#form'>
                    話を聞いてみる
                </a>
            </div>
        </section>
    )
}
